/**
 * Where "Contact support" goes.
 *
 * ONE constant, used by frames 00a and 00d. Accounts here are provisioned by an
 * administrator and there is no self-service reset, so this link is the entire recovery
 * path for an operator locked out at a vehicle — which is why it is written once rather
 * than inlined at each call site.
 *
 * Exported as the full `mailto:` as well, so a caller cannot forget the scheme.
 */
export const SUPPORT_EMAIL = 'support@scans.ai';

export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
